import { getApiErrorDetail, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Carrier } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { carrierKeys, createCarrierApi } from '../api';
import type { ReferenceCarrierRequest } from '../api';

export function useReferenceCarrier(): UseMutationResult<Carrier, Error, ReferenceCarrierRequest> {
  const client = useApiClient('admin-auth');
  const api = createCarrierApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation({
    mutationFn: (request: ReferenceCarrierRequest) => api.referenceCarrier(request),
    onError: (error: Error) => {
      const detail = getApiErrorDetail(error);
      toast.error(detail.message || t('spaces.settings.carriers.toast.referenceError'));
    },
    onSuccess: (_result, variables) => {
      toast.success(t('spaces.settings.carriers.toast.referenced'));
      void queryClient.invalidateQueries({ queryKey: carrierKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: carrierKeys.detail(variables.carrierId) });
    },
  });
}
